import { Navigate } from 'react-router-dom';

const ServicesManagement = () => (
  <Navigate to="/admin/packs-services?tab=services" replace />
);

export { ServicesManagementContent } from './ServicesManagementContent';
export default ServicesManagement;
